import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { MdSearch } from "react-icons/md";
import Button from "react-bootstrap/Button";
import { Image } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import iicon from "../../assets/i.svg";
import { ManageVouchersAPI } from "../API/Vouchers/ManageVoucher.js";
import Loader from "../../Components/Loader/Loader";
import { DeleteApi } from "./../API/Vouchers/DeleteRow";
import { UpdateApi } from "./../API/Vouchers/UpdateStatus";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { ClimbingBoxLoader } from "react-spinners";
import Pagination from "../Pagination/Pagination";
import swal from "sweetalert";
import { AutoPublishAPI } from "../API/Coupons/AutoPublish";
import NoDataText from "../NoDataText";
import SearchBarResults from "../Search/SearchBarResults";
import { Switch } from "antd";
import { UpdateFeaturedVouchersAPI } from "../API/Vouchers/updateFeatureVoucher.js";
import { FormatDateShortMonth } from "./../../Utils/DateFormatter";

const ManageVouchers = (props) => {
  const { setLoading, loading } = props;
  const [TableRows, setTableRows] = useState([]);
  const [globalTableRows, setglobalTableRows] = useState([]);
  // checkbox
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  // AutoPublish
  const [AutoPublish, setAutoPublish] = useState(0);
  const [checkAutoPublish, setcheckAutoPublish] = useState(false);
  // search
  const [searchValue, setsearchValue] = useState("");
  // err
  const [ShowTable, setShowTable] = useState(false);
  // pagination
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [limit, setLimit] = useState(0);
  // global
  const [globalTotalPageCount, setGlobalTotalPageCount] = useState(0);
  const [globalLimit, setGlobalLimit] = useState(0);
  // sort
  const [flag, setFlag] = useState({
    business_name: 0,
    voucher_name: 0,
    voucher_offer_price: 0,
    voucher_created_at: 0,
    voucher_limit: 0,
    status_name: 0,
  });

  // feature-status
  const [featureStatus, setFeatureStatus] = useState({});
  const [disabled, setDisabled] = useState(true);

  const navigate = useNavigate();

  const cityId = localStorage.getItem("cityId");

  useEffect(() => {
    getAutoPublishStatus();
  }, []);

  const getAutoPublishStatus = async () => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");
    const data = {
      switch: "",
      mms_city_id: parseInt(cityId),
      flag: "voucher",
    };
    const Response = await AutoPublishAPI(data, () => {
      navigate("/");
    });
    if (Response.status === 429) {
      swal({
        text: Response.message,
        icon: "error",
        buttons: "Ok",
      });
      setLoading(true);
    } else if (Response.data[0].status == 0) {
      setcheckAutoPublish(false);
    } else {
      setcheckAutoPublish(true);
    }
  };

  // pagination
  const pageChange = async () => {
    // setLoading(true);
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      offset: pageNumber,
    };
    const coupondetailData = await ManageVouchersAPI(data, () => {
      navigate("/");
    });

    if (coupondetailData.data.length === 0) {
      setShowTable(true);
      setLoading(false);
      setTableRows([]);
    } else if (coupondetailData.message === "No Data Available") {
      setShowTable(true);
      setLoading(false);
      setTableRows([]);
    } else {
      setTableRows(coupondetailData.data);
      setglobalTableRows(coupondetailData.data);
      setTotalPageCount(coupondetailData.total_page_count);
      setLimit(coupondetailData.limit);
      setGlobalTotalPageCount(coupondetailData.total_page_count);
      setGlobalLimit(coupondetailData.limit);
      setLoading(false);
    }
  };

  useEffect(() => {
    pageChange();
  }, [pageNumber]);

  // checkbox - th
  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(TableRows.map((li) => li.city_voucher_id));
    if (isCheckAll) {
      setIsCheck([]);
    }
  };
  // checkbox - tr
  const handleClick = (e, key) => {
    const { checked } = e.target;
    setIsCheck([...isCheck, TableRows[key].city_voucher_id]);
    if (!checked) {
      setIsCheck(
        isCheck.filter((item) => item !== TableRows[key].city_voucher_id)
      );
    }
  };

  // update status
  const handleChangeDropDown = (e, key) => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      option: "status",
      voucher_id: [TableRows[key].city_voucher_id],
      status_id: parseInt(e.target.value),
    };
    // const coupondetailData = UpdateApi(data);
    swal({
      title: `Are you sure you want to update status of "${TableRows[key].voucher_name}"?`,
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then(async (willDelete) => {
      if (willDelete) {
        const Response = await UpdateApi(data, () => {
          navigate("/");
        });
        if (Response === false) {
          swal({
            text: "Internal Server Error!",
            icon: "error",
            buttons: "Ok",
          });
        } else {
          if (Response.success == true) {
            swal({
              // title: "Success!",
              title: `"${TableRows[key].voucher_name}" status has been updated successfully!`,
              icon: "success",
              buttons: "Ok",
            }).then((isOk) => {
              if (isOk) {
                pageChange();
              }
            });
          } else {
            swal({
              text: "Please wait...",
              icon: "error",
              buttons: "Ok",
            }).then(() => {
              window.location.reload(false);
            });
          }
        }
      } else {
        swal({
          text: "Please wait...",
          icon: "error",
          buttons: "Ok",
        }).then(() => {
          window.location.reload(false);
        });
      }
    });
    setLoading(false);
  };
  const handleChangeDropDownTop = (e) => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      option: "status",
      voucher_id: isCheck,
      status_id: parseInt(e.target.value),
    };
    // const coupondetailData = UpdateApi(data);
    swal({
      title: `Are you sure you want to update status for selected voucher?`,
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        UpdateApi(data, () => {
          navigate("/");
        });
        swal({
          // title: "Success!",
          title: `Selected voucher status has been updated successfully!`,
          icon: "success",
          buttons: "Ok",
        });
        pageChange();
        // setTimeout(() => {
        //   window.location.reload(false);
        // }, 1000);
      } else {
        swal({
          text: "Please wait...",
          icon: "error",
          buttons: "Ok",
        });
        pageChange();
      }
    });
    setLoading(false);
  };

  // Delete
  const handleDelete = async () => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      option: "delete",
      voucher_id: isCheck,
    };
    // const coupondetailData = await DeleteApi(data);
    swal({
      title: `Are you sure you want to delete selected voucher?`,
      text: "Once deleted, you will not be able to recover!",
      icon: "error",
      buttons: true,
      dangerMode: false,
    }).then(async (willDelete) => {
      if (willDelete) {
        const Response = await DeleteApi(data, () => {
          navigate("/");
        });
        if (Response.success == true) {
          swal({
            // title: "Success!",
            title: `Selected voucher has been deleted successfully!`,
            icon: "success",
            buttons: "Ok",
          }).then((isOk) => {
            if (isOk) {
              setIsCheck([]);
              pageChange();
            }
          });
        } else if (Response.status === 429) {
          swal({
            text: `${Response.message}`,
            icon: "error",
            buttons: "Ok",
            dangerMode: false,
          });
          setLoading(true);
        } else {
          swal({
            text: "Please wait...",
            icon: "error",
            buttons: "Ok",
          });
          pageChange();
        }
      } else {
        swal({
          text: "Please wait...",
          icon: "error",
          buttons: "Ok",
        });
        pageChange();
      }
    });
    setLoading(false);
  };

  const handleAutoPublish = async (value) => {
    setcheckAutoPublish(!checkAutoPublish);
    const cityId = localStorage.getItem("cityId");
    const data = {
      switch: value == false ? 1 : 0,
      mms_city_id: parseInt(cityId),
      flag: "voucher",
    };
    swal({
      title: `Are you sure you want to update auto-publish status?`,
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then(async (willDelete) => {
      if (willDelete) {
        const Response = await AutoPublishAPI(data, () => {
          navigate("/");
        });
        if (Response.success == true) {
          swal({
            // title: "Success!",
            title: `Auto-publish status has been updated successfully!`,
            icon: "success",
            buttons: "Ok",
          });
        }
        if (Response.status === 429) {
          swal({
            text: Response.message,
            icon: "error",
            buttons: "Ok",
          });
          setLoading(true);
        }
      } else {
        swal({
          text: "Please wait...",
          icon: "error",
          buttons: "Ok",
        });
        setTimeout(() => {
          window.location.reload(false);
        }, 1000);
      }
    });
  };

  const handleSearchInput = (e) => {
    setsearchValue(e.target.value);
    if (e.target.value.length == 0) {
      setShowTable(false);
      setTableRows(globalTableRows);
      setTotalPageCount(globalTotalPageCount);
      setLimit(globalLimit);
    }
  };
  const handleKeypress = (e) => {
    if (e.code === "Enter") {
      handleSearch();
    }
  };
  const handleSearch = async (e) => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");

    const data = {
      mms_city_id: parseInt(cityId),
      search_value: searchValue,
      offset: searchValue ? 0 : pageNumber,
    };
    const coupondetailData = await ManageVouchersAPI(data, () => {
      navigate("/");
    });
    if (coupondetailData.status === 429) {
      swal({
        text: coupondetailData.message,
        icon: "error",
        buttons: "Ok",
      });
      setLoading(true);
    } else if (coupondetailData.success == false) {
      setShowTable(true);
      setTableRows([]);
      setLoading(false);
    } else {
      setShowTable(false);
      setTableRows(coupondetailData.data);
      setTotalPageCount(coupondetailData.total_page_count);
      setLimit(coupondetailData.limit);
      setLoading(false);
    }
  };

  // sort
  // Api for sort
  const handleSort = async (search, sortNo, colValue) => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      offset: search ? 0 : pageNumber,
      search_value: search,
      column_name: colValue,
      sort_type: sortNo,
    };
    const coupondetailData = await ManageVouchersAPI(data, () => {
      navigate("/");
    });
    // console.log(coupondetailData,"coupondetailData")
    setLoading(false);
    if (coupondetailData.message === "No Data Available") {
      setShowTable(true);
      setLoading(false);
    } else {
      setLoading(false);
      setShowTable(false);
      setTableRows(coupondetailData.data);
      setglobalTableRows(coupondetailData.data);
      setTotalPageCount(coupondetailData.total_page_count);
      setLimit(coupondetailData.limit);
    }
  };

  // function to sort-button
  const HandleSortCol = (value) => {
    // business_name: 0,
    if (value == "bi_name") {
      if (flag.business_name === 0) {
        handleSort(searchValue, 1, "bi_name");
        setFlag((item) => {
          return { ...item, business_name: 1 };
        });
      } else if (flag.business_name === 1) {
        handleSort(searchValue, 2, "bi_name");
        setFlag((item) => {
          return { ...item, business_name: 2 };
        });
      } else {
        handleSort(searchValue, 0, "bi_name");
        setFlag((item) => {
          return { ...item, business_name: 0 };
        });
      }
    }
    // voucher_name: 0,
    if (value == "voucher_name") {
      if (flag.voucher_name === 0) {
        handleSort(searchValue, 1, "voucher_name");
        setFlag((item) => {
          return { ...item, voucher_name: 1 };
        });
      } else if (flag.voucher_name === 1) {
        handleSort(searchValue, 2, "voucher_name");
        setFlag((item) => {
          return { ...item, voucher_name: 2 };
        });
      } else {
        handleSort(searchValue, 0, "voucher_name");
        setFlag((item) => {
          return { ...item, voucher_name: 0 };
        });
      }
    }
    // voucher_created_at:0
    if (value == "voucher_created_at") {
      if (flag.voucher_created_at === 0) {
        handleSort(searchValue, 1, "voucher_created_at");
        setFlag((item) => {
          return { ...item, voucher_created_at: 1 };
        });
      } else if (flag.voucher_created_at === 1) {
        handleSort(searchValue, 2, "voucher_created_at");
        setFlag((item) => {
          return { ...item, voucher_created_at: 2 };
        });
      } else {
        handleSort(searchValue, 0, "voucher_created_at");
        setFlag((item) => {
          return { ...item, voucher_created_at: 0 };
        });
      }
    }
    // voucher_offer_price: 0,
    if (value == "voucher_offer_price") {
      if (flag.voucher_offer_price === 0) {
        handleSort(searchValue, 1, "voucher_offer_price");
        setFlag((item) => {
          return { ...item, voucher_offer_price: 1 };
        });
      } else if (flag.voucher_offer_price === 1) {
        handleSort(searchValue, 2, "voucher_offer_price");
        setFlag((item) => {
          return { ...item, voucher_offer_price: 2 };
        });
      } else {
        handleSort(searchValue, 0, "voucher_offer_price");
        setFlag((item) => {
          return { ...item, voucher_offer_price: 0 };
        });
      }
    }
    // voucher_limit
    if (value == "voucher_limit") {
      if (flag.voucher_limit === 0) {
        handleSort(searchValue, 1, "voucher_limit");
        setFlag((item) => {
          return { ...item, voucher_limit: 1 };
        });
      } else if (flag.voucher_limit === 1) {
        handleSort(searchValue, 2, "voucher_limit");
        setFlag((item) => {
          return { ...item, voucher_limit: 2 };
        });
      } else {
        handleSort(searchValue, 0, "voucher_limit");
        setFlag((item) => {
          return { ...item, voucher_limit: 0 };
        });
      }
    }

    // status_name
    if (value == "status_name") {
      if (flag.status_name === 0) {
        handleSort(searchValue, 1, "status_name");
        setFlag((item) => {
          return { ...item, status_name: 1 };
        });
      } else if (flag.status_name === 1) {
        handleSort(searchValue, 2, "status_name");
        setFlag((item) => {
          return { ...item, status_name: 2 };
        });
      } else {
        handleSort(searchValue, 0, "status_name");
        setFlag((item) => {
          return { ...item, status_name: 0 };
        });
      }
    }
  };

  const handleFeatureStatus = async (checked, item) => {
    setFeatureStatus((prevState) => ({
      ...prevState,
      [item.city_voucher_id]: checked,
    }));

    const payload = {
      mms_city_id: parseInt(cityId),
      business_id: parseInt(item.business_id),
      city_voucher_id: parseInt(item.city_voucher_id),
      action_key: checked === true ? "enable" : "disable",
    };
    try {
      const response = await UpdateFeaturedVouchersAPI(payload);
      if (response.status === 429) {
        setLoading(true);
        swal({
          title: `${response.message}`,
          icon: "error",
          buttons: "OK",
        });
      } else if (response === false) {
        swal({
          title: `${response.message}`,
          icon: "error",
          buttons: "OK",
        });
      } else if (response.status === 400) {
        swal({
          title: `${response.message}`,
          icon: "error",
          buttons: "OK",
        }).then(() => {
          setLoading(true);
          window.location.reload();
        });
      } else {
        pageChange();
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <>
      <div className="manage-vou-main pt-3 pb-3 three-col-heading">
        <div className="d-flex">
          <div>
            {["top"].map((placement) => (
              <OverlayTrigger
                key={placement}
                placement={placement}
                overlay={
                  <Tooltip
                    id={`tooltip-${placement}`}
                    className="Tooltips"
                    style={{ opacity: "1" }}
                  >
                    Review status from 'New' to 'Published' or 'Declined' for
                    all vouchers businesses create.{" "}
                  </Tooltip>
                }
              >
                <Image src={iicon} className="pt-1 TTip" width="20px"></Image>
              </OverlayTrigger>
            ))}
          </div>
          <p className="page-maintitle pt-1">Manage Vouchers</p>
        </div>
        <div className="">
          <InputGroup className="search-bar  MVouchers">
            <InputGroup.Text>
              <MdSearch />
            </InputGroup.Text>
            <Form.Control
              className="search_feild"
              value={searchValue}
              onChange={(e) => handleSearchInput(e)}
              onKeyPress={handleKeypress}
            />
            <Button variant="outline-secondary" onClick={handleSearch}>
              Search
            </Button>
          </InputGroup>
        </div>
        <div className="manage-vou d-flex">
          <div>
            {["top"].map((placement) => (
              <OverlayTrigger
                key={placement}
                placement={placement}
                overlay={
                  <Tooltip
                    id={`tooltip-${placement}`}
                    className="Tooltips"
                    style={{ opacity: "1" }}
                  >
                    Enable 'Auto-publish' to automatically publish all vouchers
                    created by businesses without your approval.
                  </Tooltip>
                }
              >
                <Image src={iicon} className="pt-1" width="20px"></Image>
              </OverlayTrigger>
            ))}
          </div>
          <p className="page-maintitle pt-1">Auto Publish </p>
          <Form.Check
            type="switch"
            id="custom-switch"
            className="switch-sec mt-1 pt-1"
            checked={checkAutoPublish}
            onChange={() => handleAutoPublish(checkAutoPublish)}
          />
        </div>
      </div>
      <SearchBarResults SearchValue={searchValue} />
      {isCheck.length != 0 ? (
        <div className="d-flex">
          <Button
            className="green-btn width-150 p-0 mr-3"
            onClick={handleDelete}
          >
            Delete Selected
          </Button>
          <Form.Select
            aria-label="Default select example"
            className="table-select width-150 ml-3 status_select"
            onChange={handleChangeDropDownTop}
          >
            <option>Select Status</option>
            {TableRows.length != 0 ? (
              <>
                {TableRows[0]?.status_list.map((i, k) => {
                  return <option value={i.id}>{i.status}</option>;
                })}
              </>
            ) : (
              ""
            )}
          </Form.Select>
        </div>
      ) : (
        ""
      )}
      {/* table */}{" "}
      <div class="table-responsive-xl black-header">
        <table class="recentact-table mt-3 table ver-middle manage-vou-table manage-voulist-Table">
          <thead>
            <tr>
              <th className="radio-colors">
                <Form.Check
                  aria-label="option 1"
                  className="orange-checkbox"
                  onChange={handleSelectAll}
                  checked={isCheckAll}
                />
              </th>
              <th
                className="tableHead"
                onClick={() => HandleSortCol("voucher_name")}
              >
                <Button className="btn btn-primary sortIcon">
                  Voucher Name{" "}
                  {flag.voucher_name === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.voucher_name === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th onClick={() => HandleSortCol("bi_name")}>
                <Button className="btn btn-primary sortIcon">
                  Business Name
                  {flag.business_name === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.business_name === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th onClick={() => HandleSortCol("voucher_offer_price")}>
                <Button className="btn btn-primary sortIcon">
                  Voucher Price
                  {flag.voucher_offer_price === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.voucher_offer_price === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>

              <th onClick={() => HandleSortCol("voucher_limit")}>
                <Button className="btn btn-primary sortIcon">
                  Total Vouchers{" "}
                  {flag.voucher_limit === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.voucher_limit === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th onClick={() => HandleSortCol("voucher_created_at")}>
                <Button className="btn btn-primary sortIcon">
                  Created Date{" "}
                  {flag.voucher_created_at === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.voucher_created_at === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th>Featured</th>
              <th
                onClick={() => HandleSortCol("status_name")}
                style={{ borderTopRightRadius: "15px" }}
              >
                <Button className="btn btn-primary sortIcon">
                  Status{" "}
                  {flag.status_name === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.status_name === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
            </tr>
          </thead>
          <tbody>
            {ShowTable === false ? (
              // {TableRows?.length != 0 ? (
              <>
                {TableRows.map((item, key) => {
                  return (
                    <>
                      <tr>
                        <td className="radio-colors">
                          <Form.Check
                            aria-label="option 1"
                            className="orange-checkbox"
                            onChange={(e) => handleClick(e, key)}
                            checked={isCheck.includes(item.city_voucher_id)}
                          />
                        </td>
                        <td style={{ textAlign: "left" }}>
                          <Link
                            className="vouname-blue"
                            to={`/vouchers/voucherDetails/${item.city_voucher_id}`}
                            title={item.voucher_name}
                          >
                            {item.voucher_name.length > 40
                              ? item.voucher_name.substring(0, 43) + "..."
                              : item.voucher_name}
                          </Link>
                        </td>
                        <td style={{ textAlign: "left" }}>
                          {item.business_name}
                        </td>

                        <td style={{ textAlign: "end" }}>
                          ${item.voucher_price}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {item.available_voucher}
                        </td>

                        <td
                          className="date-col"
                          style={{ textAlign: "center" }}
                        >
                          {FormatDateShortMonth(item.created_at)}
                        </td>
                        <td>
                          <Switch
                            className="switch-button"
                            checkedChildren="Enable"
                            unCheckedChildren="Disable"
                            disabled={
                              item.status_name !== "Published"
                                ? disabled
                                : !disabled
                            }
                            checked={
                              featureStatus[item.city_voucher_id] ||
                              item.is_featured === true
                                ? true
                                : false
                            }
                            onChange={(checked) => {
                              handleFeatureStatus(checked, item);
                            }}
                          />
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <Form.Select
                            aria-label="Default select example"
                            className="table-select status_select"
                            onChange={(e) => handleChangeDropDown(e, key)}
                          >
                            {item.status_list.map((i, k) => {
                              return (
                                <option
                                  value={i.id}
                                  selected={
                                    item.status_id === i.id ? "selected" : ""
                                  }
                                >
                                  {i.status}
                                </option>
                              );
                            })}
                          </Form.Select>
                        </td>
                      </tr>
                    </>
                  );
                })}
              </>
            ) : (
              <tr class="toggle-row">
                <td colspan="8">
                  <p class="noData">{NoDataText.ErrText}</p>{" "}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {TableRows.length !== 0 ? (
        <Pagination
          totalPageCount={totalPageCount}
          setPageNumber={setPageNumber}
          limit={limit}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default ManageVouchers;
